<template>
  <div class="menu-popup">
    <slide-y-up-transition>
      <div
        v-if="show && filteredItems.length"
        class="menu-popup__items mobile-none tablet-none"
        v-click-outside="closeWithOutsideClick"
      >
        <MenuPopupContent
          v-for="(item, index) in filteredItems"
          :key="`menu-popup-${index}`"
          :item="item"
          :rowItem="rowItem"
        />
        <div class="padding-x-16"><slot name="bottom-area"></slot></div>
      </div>
    </slide-y-up-transition>
    <MobilePopup :show="show" @setShow="close">
      <template>
        <div>
          <MenuPopupContent
            v-for="(item, index) in filteredItems"
            :key="`menu-popup-${index}`"
            :item="item"
            :rowItem="rowItem"
          />
          <div><slot name="bottom-area"></slot></div>
        </div>
      </template>
    </MobilePopup>
  </div>
</template>

<script>
import MobilePopup from "./MobilePopup.vue";
import MenuPopupContent from "./MenuPopupContent.vue";
import {
  checkPermission,
  checkScreenDevice,
  generateLang,
} from "@/shared/utils";
import { computed, toRefs } from "vue";

export default {
  components: { MobilePopup, MenuPopupContent },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    permissions: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Boolean,
      default: false,
    },
    rowItem: {
      type: [Object, Number, String],
      default: null,
    },
  },
  setup(props, { emit }) {
    // bind props
    const { items, permissions } = toRefs(props);

    const close = () => emit("close");

    const filteredItems = computed(() => {
      let newItems = [...items.value];

      // filtered items by show key
      newItems = newItems.filter(({ show }) => show);

      // filtered items by permissions
      newItems = newItems.filter((item) => {
        return checkPermission(permissions.value, item.permissions);
      });

      // convert edit item to view item when permission is view
      newItems = newItems.map((item) => {
        let icon = item.icon;
        let caption = item.caption;
        if (
          icon === "pencil-outline" &&
          caption === generateLang(["edit"]) &&
          checkPermission(permissions.value, ["view"])
        ) {
          icon = "eye-outline";
          caption = generateLang(["show"]);
        }

        return {
          ...item,
          icon,
          caption,
        };
      });

      return newItems;
    });

    const closeWithOutsideClick = () => {
      if (!checkScreenDevice(["desktop"])) return;
      close();
    };

    // return data to be used in template
    return { filteredItems, close, closeWithOutsideClick };
  },
};
</script>
